/**
 * @generated SignedSource<<f3edd41e23a18743debefa10ada0d42c>>
 * @relayHash 703bcd9cc4771cb7955e67364c879f62
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 703bcd9cc4771cb7955e67364c879f62

import { ConcreteRequest } from 'relay-runtime';
export type AppointmentType = "FLAT_LENGTH_FULL_HOUR" | "FOLLOW_UP" | "LONGER" | "NORMAL";
export type CommunicationChannel = "ASYNC_REQUEST" | "CHAT" | "PHONE" | "VIDEO";
export type Country = "CH" | "DE";
export type Gender = "FEMALE" | "MALE" | "OTHER" | "UNKNOWN";
export type Language = "ENGLISH" | "FRENCH" | "GERMAN" | "ITALIAN";
export type Service = "ADMINISTRATIVE_REQUEST" | "CONSULTATION" | "EMERGENCY_LINE" | "KIDS_LINE" | "MEDGATE_CONNECT" | "PREVENTION_ASSESSMENT" | "PSYCHOSOCIAL" | "STUDY_CALL" | "TELE_GENERAL_PRACTITIONER";
export type ServiceSpecialty = "CARDIOLOGY" | "DERMATOLOGY" | "GYNAECOLOGY" | "LONG_COVID" | "NONE" | "OTORHINOLARYNGOLOGY" | "PEDIATRICS" | "UROLOGY" | "VACCINATION_AND_TRAVEL_ADVICE";
export type GetAvailableDatesCapacityInput = {
  agentUserNameOrGender?: FilterByAgentUserNameOrGenderInput | null;
  appointmentType: AppointmentType;
  channel: CommunicationChannel;
  language: Language;
  licensedInCountry: Country;
  rescheduledAppointmentId?: string | null;
  service: Service;
  specialty: ServiceSpecialty;
};
export type FilterByAgentUserNameOrGenderInput = {
  agentGender: Gender;
  agentUserName?: never;
} | {
  agentGender?: never;
  agentUserName: string;
};
export type useAvailableDatesCapacityQuery$variables = {
  input: GetAvailableDatesCapacityInput;
};
export type useAvailableDatesCapacityQuery$data = {
  readonly availableDatesCapacity: {
    readonly availableDates: ReadonlyArray<any>;
    readonly isIrrelevant: boolean;
  };
};
export type useAvailableDatesCapacityQuery = {
  response: useAvailableDatesCapacityQuery$data;
  variables: useAvailableDatesCapacityQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "filter",
        "variableName": "input"
      }
    ],
    "concreteType": "GetAvailableDatesOutput",
    "kind": "LinkedField",
    "name": "availableDatesCapacity",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "availableDates",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "isIrrelevant",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useAvailableDatesCapacityQuery",
    "selections": (v1/*:: as any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "useAvailableDatesCapacityQuery",
    "selections": (v1/*:: as any*/)
  },
  "params": {
    "id": "703bcd9cc4771cb7955e67364c879f62",
    "metadata": {},
    "name": "useAvailableDatesCapacityQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "5407e0eeaef7489b2ad0efaf2ad5b2a9";

export default node;
